import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const unlock = (email) => axios.post(`${API}/unlock`, { email });
export const saveAnswers = (payload) => axios.post(`${API}/answers`, payload);

export const spawnSparks = (rect, count) => {
  for (let i = 0; i < count; i++) {
    const s = document.createElement("div");
    s.className = "spark";
    s.style.left = `${rect.left + Math.random() * rect.width}px`;
    s.style.top = `${rect.top + Math.random() * rect.height}px`;
    s.style.setProperty("--drift", `${Math.random() * 160 - 80}px`);
    s.style.animationDelay = `${Math.random() * 0.5}s`;
    document.body.appendChild(s);
    setTimeout(() => s.remove(), 2000);
  }
};

export const flash = (setter, msg, ms = 2500) => {
  setter(msg);
  setTimeout(() => setter(""), ms);
};

export const ai = (task, text, context = "") => axios.post(`${API}/method/ai`, { task, text, context }).then((r) => r.data);
export const saveProtocol = (email, protocol) => axios.post(`${API}/protocol`, { email, protocol });

const pad = (n) => String(n).padStart(2, "0");
const icsStamp = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;

export const scheduleLinks = (title, date, time) => {
  const start = new Date(`${date}T${time || "09:00"}:00`);
  const end = new Date(start.getTime() + 30 * 60000);
  const details = "A fearless action from my Modern Mind Manifestation Protocol.";
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${icsStamp(start)}/${icsStamp(end)}&details=${encodeURIComponent(details)}`;
  const download = () => {
    const ics = [
      "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Modern Mind//Manifestation Method//EN", "BEGIN:VEVENT",
      `UID:mm-${Date.now()}@modernmind.earth`, `DTSTAMP:${icsStamp(new Date())}`, `DTSTART:${icsStamp(start)}`, `DTEND:${icsStamp(end)}`,
      `SUMMARY:${title}`, `DESCRIPTION:${details}`, "END:VEVENT", "END:VCALENDAR",
    ].join("\r\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
    a.download = "fearless-action.ics";
    a.click();
  };
  return { google, download };
};

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
